module.exports = __webpack_public_path__ + "img/img_customers_04.71c08151.png";